import { useContext } from 'react';
import { StoreContext } from '@roc/feature-app-core';
import { Store } from '../stores';

export const useStore = () => useContext<Store>(StoreContext);
